import emailjs from '@emailjs/browser';

// ✅ Remplace par les bons IDs de TON compte EmailJS
const EMAILJS_CONFIG = {
  publicKey: 'E1wX52a9IB3tFjMtO',
  serviceID: 'service_ilq48kq',  // ← Le service qui a fonctionné dans le test
  templateClient: 'template_yusbf1g',
  templateAdmin: 'template_ik6uudw',
  adminEmail: 'tedbet359@gmail.com'
};

// Initialiser EmailJS
emailjs.init(EMAILJS_CONFIG.publicKey);

/**
 * Envoyer un email de confirmation au client
 */
export const sendClientEmail = async (orderData, clientEmail) => {
  try {
    if (!clientEmail || clientEmail === '') {
      console.log('⚠️ Email client vide, envoi ignoré');
      return { success: false, error: 'Email client manquant' };
    }
    
    console.log('📧 Envoi email client vers:', clientEmail);
    
    let itemsHtml = '';
    if (orderData.items && orderData.items.length > 0) {
      itemsHtml = orderData.items.map(item => `
        <tr style="border-bottom: 1px solid #E5E7EB;">
          <td style="padding: 12px 8px; font-size: 14px; color: #2D2D2D; text-align: left;">${item.name}</td>
          <td style="padding: 12px 8px; font-size: 14px; color: #2D2D2D; text-align: center;">x${item.quantity}</td>
          <td style="padding: 12px 8px; font-size: 14px; font-weight: 600; color: #0B1A33; text-align: right;">${(item.price * item.quantity).toFixed(2)} €</td>
        </tr>
      `).join('');
    }

    let deliveryDateFormatted = 'À définir';
    if (orderData.deliveryDate) {
      const dateObj = new Date(orderData.deliveryDate);
      if (!isNaN(dateObj.getTime())) {
        deliveryDateFormatted = dateObj.toLocaleDateString('fr-FR', { 
          weekday: 'long', 
          day: 'numeric', 
          month: 'long', 
          year: 'numeric' 
        });
      }
    }

    const templateParams = {
      email: clientEmail,
      to_name: orderData.customerName || 'Client',
      order_number: orderData.orderNumber || 'N/A',
      order_date: new Date().toLocaleDateString('fr-FR', { 
        day: 'numeric', 
        month: 'long', 
        year: 'numeric' 
      }),
      delivery_address: orderData.deliveryAddress || 'Non renseignée',
      delivery_city: orderData.deliveryCity || 'Non renseignée',
      delivery_postal: orderData.deliveryPostal || 'Non renseigné',
      delivery_date: deliveryDateFormatted,
      delivery_slot: orderData.deliverySlot || 'Flexible',
      delivery_floor: orderData.deliveryFloor || 'Non renseigné',
      has_elevator: orderData.hasElevator ? 'Oui' : 'Non',
      deposit_at_door: orderData.depositAtDoor ? '✅ Oui' : '❌ Non',
      notes: orderData.notes || 'Aucune instruction',
      items_html: itemsHtml || '<tr><td colspan="3" style="padding: 12px; text-align: center; color: #6B7280;">Aucun produit</td></tr>',
      subtotal: orderData.totalAmount ? orderData.totalAmount.toFixed(2) : '0.00',
      delivery_fee: orderData.deliveryFee ? orderData.deliveryFee.toFixed(2) : '0.00',
      total: orderData.grandTotal ? orderData.grandTotal.toFixed(2) : '0.00',
      payment_method: orderData.paymentMethod === 'online' ? '💳 Paiement en ligne' : '💵 Paiement à la livraison'
    };

    console.log('📤 Paramètres template client:', templateParams);

    const response = await emailjs.send(
      EMAILJS_CONFIG.serviceID,
      EMAILJS_CONFIG.templateClient,
      templateParams
    );

    console.log('✅ Email client envoyé:', response.status);
    return { success: true, status: response.status };
  } catch (error) {
    console.error('❌ Erreur envoi email client:', error);
    return { success: false, error: error.text || error.message };
  }
};

/**
 * Envoyer un email à l'admin (entreprise)
 */
export const sendAdminEmail = async (orderData) => {
  try {
    console.log('📧 Envoi email admin vers:', EMAILJS_CONFIG.adminEmail);
    
    let itemsHtml = '';
    if (orderData.items && orderData.items.length > 0) {
      itemsHtml = orderData.items.map(item => `
        <tr style="border-bottom: 1px solid #E5E7EB;">
          <td style="padding: 12px 8px; font-size: 14px; color: #2D2D2D; text-align: left;">${item.name}</td>
          <td style="padding: 12px 8px; font-size: 14px; color: #2D2D2D; text-align: center;">x${item.quantity}</td>
          <td style="padding: 12px 8px; font-size: 14px; font-weight: 600; color: #0B1A33; text-align: right;">${(item.price * item.quantity).toFixed(2)} €</td>
        </tr>
      `).join('');
    }

    let deliveryDateFormatted = 'À définir';
    if (orderData.deliveryDate) {
      const dateObj = new Date(orderData.deliveryDate);
      if (!isNaN(dateObj.getTime())) {
        deliveryDateFormatted = dateObj.toLocaleDateString('fr-FR', { 
          weekday: 'long', 
          day: 'numeric', 
          month: 'long', 
          year: 'numeric' 
        });
      }
    }

    const templateParams = {
      order_number: orderData.orderNumber || 'N/A',
      order_date: new Date().toLocaleDateString('fr-FR', { 
        day: 'numeric', 
        month: 'long', 
        year: 'numeric' 
      }),
      customer_name: orderData.customerName || 'Non renseigné',
      customer_email: orderData.customerEmail || 'Non renseigné',
      customer_phone: orderData.customerPhone || 'Non renseigné',
      delivery_address: orderData.deliveryAddress || 'Non renseignée',
      delivery_city: orderData.deliveryCity || 'Non renseignée',
      delivery_postal: orderData.deliveryPostal || 'Non renseigné',
      delivery_date: deliveryDateFormatted,
      delivery_slot: orderData.deliverySlot || 'Flexible',
      delivery_floor: orderData.deliveryFloor || 'Non renseigné',
      has_elevator: orderData.hasElevator ? '✅ Oui' : '❌ Non',
      deposit_at_door: orderData.depositAtDoor ? '✅ Oui' : '❌ Non',
      notes: orderData.notes || 'Aucune instruction',
      items_html: itemsHtml || '<tr><td colspan="3" style="padding: 12px; text-align: center; color: #6B7280;">Aucun produit</td></tr>',
      subtotal: orderData.totalAmount ? orderData.totalAmount.toFixed(2) : '0.00',
      delivery_fee: orderData.deliveryFee ? orderData.deliveryFee.toFixed(2) : '0.00',
      total: orderData.grandTotal ? orderData.grandTotal.toFixed(2) : '0.00',
      payment_method: orderData.paymentMethod === 'online' ? '💳 Paiement en ligne' : '💵 Paiement à la livraison'
    };

    console.log('📤 Paramètres template admin:', templateParams);

    const response = await emailjs.send(
      EMAILJS_CONFIG.serviceID,
      EMAILJS_CONFIG.templateAdmin,
      templateParams
    );

    console.log('✅ Email admin envoyé:', response.status);
    return { success: true, status: response.status };
  } catch (error) {
    console.error('❌ Erreur envoi email admin:', error);
    return { success: false, error: error.text || error.message };
  }
};

/**
 * Envoyer les deux emails (client + admin)
 */
export const sendOrderEmails = async (orderData, clientEmail) => {
  try {
    console.log('🚀 Début envoi des emails de commande...');
    console.log('📧 Email client:', clientEmail);
    
    if (!clientEmail || clientEmail === '') {
      console.log('⚠️ Email client vide, envoi seulement à l\'admin');
      const adminResult = await sendAdminEmail(orderData);
      return {
        client: { success: false, error: 'Email client manquant' },
        admin: adminResult,
        success: adminResult.success
      };
    }
    
    const [clientResult, adminResult] = await Promise.all([
      sendClientEmail(orderData, clientEmail),
      sendAdminEmail(orderData)
    ]);

    console.log('📊 Résultat client:', clientResult);
    console.log('📊 Résultat admin:', adminResult);

    return {
      client: clientResult,
      admin: adminResult,
      success: clientResult.success && adminResult.success
    };
  } catch (error) {
    console.error('❌ Erreur envoi des emails de commande:', error);
    return { success: false, error: error.message };
  }
};

const emailService = {
  sendClientEmail,
  sendAdminEmail,
  sendOrderEmails
};

export default emailService;